const logs = []

export const logEvent = (type, details) => {
  logs.push({ type, details, timestamp: new Date() })
  // console[type === 'error' ? 'error' : 'log'](`[${type.toUpperCase()}]:`, details);
}

export const getLogs = () => logs
